module.exports = __webpack_public_path__ + "static/media/new-session.662e3a1d.jpeg";